import { gql } from "@apollo/client";

const CREATE_OWNER = gql`
  mutation CreateOwner($data: CreateOwnerInput!) {
    createOwner(data: $data) {
      owner {
        id
        name
        email
        password
      }
      # token
    }
  }
`;

const LOGIN_OWNER = gql`
  mutation LoginOwner($data: LoginOwnerInput!) {
    loginOwner(data: $data) {
      owner {
        id
        name
        email
        password
      }
      token
    }
  }
`;

const LOGOUT_OWNER = gql`
  mutation LogoutOwner {
    logoutOwner
  }
`;
const UPDATE_OWNER = gql`
  mutation UpdateOwner($data: UpdateOwnerInput!) {
    updateOwner(data: $data) {
      id
      name
      email
      isActive
    }
  }
`;

const UPDATE_OWNER_PASSWORD = gql`
  mutation UpdateOwnerPassword($data: UpdateOwnerPasswordInput!) {
    updateOwnerPassword(data: $data) {
      id
      name
      email
    }
  }
`;

const DELETE_OWNER = gql`
  mutation DeleteOwner {
    deleteOwner {
      id
      name
      email
    }
  }
`;

const UPDATE_QRCODE = gql`
  mutation UpdateQRCode($data: UpdateQRCodeInput!) {
    updateQRCode(data: $data) {
      id
    }
  }
`;

const GET_IMG_URL = gql`
  mutation GetImgUrl($data: GetImgUrlInput!) {
    getImgUrl(data: $data) 
      
  }
`;

export {
  CREATE_OWNER,
  LOGIN_OWNER,
  LOGOUT_OWNER,
  UPDATE_OWNER,
  UPDATE_OWNER_PASSWORD,
  DELETE_OWNER,
  UPDATE_QRCODE,
  GET_IMG_URL
};
